<template>
  <div v-if="is_authenticated">
    <!-- 个人信息 -->
    <div class="center_info">
      <div class="info_bg"></div>
      <div class="info_head">
        <van-image
          round
          width="80"
          height="80"
          :src="imgDataUrl"
        />
        <div>{{ account_name }}</div>
      </div>
    </div>
    <!-- 菜单 -->
    <van-cell-group :border="false">
      <van-cell title="账号资料" size="large" is-link @click="goPath('/mobile/center/account')"></van-cell>
      <van-cell title="我的课程" size="large" is-link @click="goPath('/mobile/center/course')"></van-cell>
      <van-cell title="我的证书" size="large" is-link @click="goPath('/mobile/center/certificate')"></van-cell>
      <van-cell title="我的实验" size="large" is-link @click="goPath('/mobile/center/experiment')"></van-cell>
      <van-cell title="我的授权码" size="large" is-link @click="goPath('/mobile/center/code')"></van-cell>
      <van-cell title="我的卡包" size="large" is-link @click="goPath('/mobile/center/card')"></van-cell>
      <van-cell title="我的收藏" size="large" is-link @click="goPath('/mobile/center/collect')"></van-cell>
      <van-cell title="我的订单" size="large" is-link @click="goPath('/mobile/center/order')"></van-cell>
      <van-cell title="我的开票" size="large" is-link @click="goPath('/mobile/center/ticket')"></van-cell>
      <van-cell title="退出登录" size="large" @click="logOutOpt"></van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import { GetUserState, LogOutUser } from 'api/user/auth/login'
  import { routePathHandler } from 'utils/common'

  export default {
    inheritAttrs: false,
    components: {
    },
    data() {
      return {
        is_authenticated: false,
        account_name: '',
        activeMenu: '',
        sideMenu:[{
          name: '账号资料',
          url: '/center/account'
        },{
          name: '我的课程',
          url: '/center/course'
        },{
          name: '我的授权码',
          url: '/center/code'
        },{
          name: '我的卡包',
          url: '/center/card/vip_card'
        },{
          name: '我的收藏',
          url: '/center/collect'
        },{
          name: '我的订单',
          url: '/center/order'
        },{
          name: '我的开票',
          url: '/center/ticket'
        }],

        show: false,
        params: {
            token: '123456798',
            name: 'avatar1'
        },
        imgDataUrl: require('/src/assets/img/logo.png')    //assets中文件需用require方式加载
      }
    },
    created() {
      GetUserState()
          .then((res) => {
            if (res.id) {
              this.is_authenticated = true;
              this.account_name = res.username;
              if (res.avatar) {
                this.imgDataUrl = res.avatar;
              }
            } else {
              this.$emit('update:loginVisible', true);
            }
          });
    },
    mounted() {
      this.$emit('update:isShowHeader', true);
      this.$emit('update:isAddExtraClass', true);
      let path = this.$route.path;
      this.pathHandler(path);
      window.newThirdBindCellphone = this.newThirdBindCellphone;
    },
    unmounted() {
      this.$emit('update:isAddExtraClass', false);
    },
    methods: {
      pathHandler(path) {
        const routePath = routePathHandler(path);
        let activePath;
        if(routePath === '/center/ticket/apply') {
          activePath = '/center/ticket'
        } else {
          activePath = routePath;
        }
        this.activeMenu = activePath;
      },
      toggleShow() {
          this.show = !this.show;
      },
      cropUploadSuccess(jsonData, field){
        this.$router.go(0);
          // this.imgDataUrl = jsonData.url;
          // this.toggleShow();
          // this.$refs.avatarUpload.setStep(1)
      },
      cropUploadFail(status, field){

      },

      logOutOpt() {
        LogOutUser().then((res) => {
          window.location.href = "/mobile/home";
        })
      },
      goPath(path) {
        this.$router.push(path);
      },
    },
    watch: {
      '$route' (to, from) {
        let path = to.path;
        this.pathHandler(path);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .center_info {
    height:150px;
    .info_bg {
      height:60px;
      background:#009dd9 url('~@/assets/img/bg/center_bg.png') center bottom no-repeat;
      background-size:100% 100%;
    }
    .info_head {
      text-align: center;
      margin-top: -40px;
      font-size:16px;
      .van-image {
        margin-bottom:10px;
      }
    }
  }
</style>
